import DeviceNumberPicker from 'components/DeviceNumber';
import styled from 'styled-components';
import storage from 'utils/sessionStorage';
import { isPosApp } from 'utils/is-pos-app';
import AlarmClockUI from './AlarmClockUI';
import Logo from './Logo';

const Ontiloo = () => {
  // Inside the POS app the station comes from the app itself, so the chip only
  // reports it — tapping must not open the station picker.
  const canChangeStation = !isPosApp();

  const handleChooseDevice = async () => {
    const deviceNum = await DeviceNumberPicker.open();
    if (!deviceNum) return;
    storage.deviceCode.set(deviceNum.toString());
    location.reload();
  };
  return (
    <Container>
      <Logo />
      <div className="divider" />
      <AlarmClockUI />
      <StationNumber onClick={handleChooseDevice} disabled={!canChangeStation} type='button'><span>Device: {storage.deviceCode.get() || '0'}</span></StationNumber>
    </Container>
  );
};

export default Ontiloo;
const Container = styled.div`
  display: flex;
  align-items: center;
  .divider {
    background: #FFEFEB;
    width: 1px;
    height: 40px;
    margin: 0 24px;
  }
`;

const StationNumber = styled.button`
  margin-left: 16px;
  background: #fff;
  padding: 2px 8px;
  border-radius: 8px;
  span {
    color: #000;
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  &:active {
    opacity: 0.6;
  }

  /* Read-only in the POS app: keep the normal look, drop the pressed feedback. */
  &:disabled {
    cursor: default;
    opacity: 1;
  }
`;
